module.exports = __webpack_public_path__ + "media/images/emails/logo-edone-0d6403b3e32d72f0ff32e607f2a96154.png";